import { useTheme } from '@emotion/react';
import { Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';

interface DisplayTextProps {
    label: string;
    value: string | string[];
    color?: string;
}

function DisplayText({ label, value, color }: DisplayTextProps) {
    const theme = useTheme();

    return (
        <Flex
            flexDirection="column"
            color={theme.palette.text.primary}
            fontSize="14px"
            lineHeight="21px"
            flex={1}
        >
            <Typography fontWeight={600}>{label}</Typography>
            {typeof value === 'string' ? (
                <Typography fontWeight={color ? 600 : 400} color={color}>
                    {value}
                </Typography>
            ) : (
                (value ?? []).map((item, index) => {
                    const isLastItem = value?.length - 1 === index;
                    if (isLastItem) {
                        return (
                            <Typography
                                key={`item-${item}-${index}`}
                                fontSize="14px"
                                color={theme.palette.text.primary}
                                fontWeight={400}
                                lineHeight="30px"
                            >
                                {item}
                            </Typography>
                        );
                    }
                    return (
                        <Typography
                            key={`item-${item}-${index}`}
                            fontSize="14px"
                            color={theme.palette.text.primary}
                            fontWeight={400}
                            lineHeight="30px"
                        >
                            {item},
                            <br />
                        </Typography>
                    );
                })
            )}
        </Flex>
    );
}

export default DisplayText;
